export enum AppFeatureExtensions {
  REFERRAL_EXTENDED = 'referral-extended',
  CE_AUTH0_CONNECTION_EXTENSION = 'ce-auth0-connection-extension'
}
